/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { PasswordStrengthRequest, PasswordStrengthResponse } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPasswordStrengthController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-password-strength-controller
   * @name CheckPasswordStrength
   * @request POST:/api/v1/password-strength
   * @deprecated
   */
  checkPasswordStrength = (data: PasswordStrengthRequest, params: RequestParams = {}) =>
    this.http.request<PasswordStrengthResponse, any>({
      path: `/v1/password-strength`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static checkPasswordStrengthPath = '/v1/password-strength'
  static checkPasswordStrengthMethod = 'POST'
}
